module.exports = __webpack_public_path__ + "img/play.f73c80e4.svg";